import React from 'react';
import { Drawer } from '@mui/material';

const styles = {
  paper: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    bgcolor: 'background.paper',
    mx: 'auto',
    width: '100%',
  },
};

export default function BaseDrawer({
  open,
  onClose,
  children,
  height,
  maxHeight = '75vh',
  maxWidth = 600,
}) {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          ...styles.paper,
          ...(height ? { height, maxHeight: height } : { maxHeight }),
          maxWidth,
        },
      }}
    >
      {children}
    </Drawer>
  );
}
